<template>
  <v-dialog v-model="dialog" width="320">
    <v-card>
      <v-card-title>
        <v-icon class="mr-2">mdi-folder-multiple-image</v-icon>画像一括ダウンロード
      </v-card-title>
      <v-card-text>
        <h3>条件</h3>
        <div>
          ・縦 × 横 ≧ {{ rdsService.maxAreaOfImage }} 以上の画像が対象
          <br />・１画像１回APIコール
          <br />
        </div>
        <h3 class="mt-3">現在の状況</h3>
        <table width="220px">
          <tr>
            <td>ダウンロードする画像数</td>
            <td align="right">
              <b>{{ rest }}</b>
            </td>
          </tr>
          <tr>
            <td>残APIコール数</td>
            <td align="right">
              <b>{{ evernote.getAPIRestCount() }}</b>
            </td>
          </tr>
          <tr>
            <td>実行後の残APIコール数</td>
            <td align="right">
              <b>{{ evernote.getAPILimitCount() - rest }}</b>
            </td>
          </tr>
          <tr class="reset_word">
            <td>次のリセット時刻</td>
            <td align="right">
              <b>{{ new Date().getHours() + 1 }}:00</b>
            </td>
          </tr>
        </table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="onCancel">キャンセル</v-btn>
        <v-btn text @click="onProceed">ダウンロード実行</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import evernote from '@/services/EvernoteService'
import rdsService from '@/services/ResourceDisplayService'

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      rest: 0
    }
  },
  computed: {
    evernote: () => evernote,
    rdsService: () => rdsService
  },
  methods: {
    open() {
      this.dialog = true
      this.rest = rdsService.numberOfLoadableImages
      return new Promise(resolve => (this.resolve = resolve))
    },
    close(result) {
      this.dialog = false
      this.resolve(result)
    },
    onCancel() {
      this.close(false)
    },
    onProceed() {
      this.close(true)
    }
  }
}
</script>

<style scoped>
.reset_word {
  color: green;
  font-weight: bold;
}
</style>
